import React, { useContext } from 'react';
import { isRequiredContactWebsite } from '../../../utils/completes';
import { ProfileContext } from '../../../context/Profile.context';
import { Pencil, X } from 'lucide-react';
import { Box, Button, TextField, SectionTitle } from '@otcmarketsgroup/otcm-ui-lib';
import { errors } from '../../../constants';
import { isPhone, isEmail, isWebsite } from '../../../utils/validations';

const CompanyContactInformation = () => {
    const [profileState, dispatchProfile] = useContext(ProfileContext);
    const profileData = profileState.profile;
    const isReadOnly = profileState.readOnly;
    const isWebsiteRequired = isRequiredContactWebsite(profileData);

    const onPhoneChange = e => {
        const value = e.target.value;
        if (/^[0-9()\-+ ]*$/.test(value)) {
            onValueChanged({ contactInfo: { ...profileData.contactInfo, basicContactInfo: { ...profileData.contactInfo.basicContactInfo, phone: value } } });
        }
    };

    const onValueChanged = updatedObj => {
        dispatchProfile({
            type: 'UPDATE_PROFILE',
            field: 'contactInfo',
            payload: updatedObj.contactInfo
        });
    };

    return <Box>
        <Box>
            <SectionTitle noUnderline>Company Contact Information</SectionTitle>
        </Box>
        <Box display='grid' gap={2} gridTemplateColumns={{ desktop: 'repeat(6, 1fr)', tablet: '1fr', mobile: '1fr' }}>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='phone'
                    type="text"
                    label="Phone Number"
                    error={!profileData.contactInfo.basicContactInfo.phone || !isPhone(profileData.contactInfo.basicContactInfo.phone)}
                    helperText={(!profileData.contactInfo.basicContactInfo.phone) ? !isReadOnly && errors.INCOMPLETE_DATA_FIELD : !isPhone(profileData.contactInfo.basicContactInfo.phone) ? 'Please enter a valid phone number' : undefined}
                    value={isReadOnly ? profileData.contactInfo.basicContactInfo.phone : profileData.contactInfo.basicContactInfo.phone}
                    placeholder='Enter text here'
                    showClearButton
                    onChange={onPhoneChange}
                    readOnly={isReadOnly}
                    maxLength={19}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='email'
                    type="text"
                    label="Email"
                    error={!profileData.contactInfo.basicContactInfo.email || !isEmail(profileData.contactInfo.basicContactInfo.email)}
                    helperText={!isReadOnly && (!profileData.contactInfo.basicContactInfo.email ? errors.INCOMPLETE_DATA_FIELD : !isEmail(profileData.contactInfo.basicContactInfo.email) ? 'Please enter a valid email' : '')}
                    value={profileData?.contactInfo?.basicContactInfo?.email}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, basicContactInfo: { ...profileData.contactInfo.basicContactInfo, email: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='website'
                    type="text"
                    label="Website"
                    error={(isWebsiteRequired && !profileData.contactInfo.basicContactInfo.website) || !isWebsite(profileData.contactInfo.basicContactInfo.website)}
                    helperText={!isReadOnly && ((isWebsiteRequired && !profileData.contactInfo.basicContactInfo.website) ? errors.INCOMPLETE_DATA_FIELD : !isWebsite(profileData.contactInfo.basicContactInfo.website) ? 'Please enter a valid website' : '')}
                    value={profileData?.contactInfo?.basicContactInfo?.website}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, basicContactInfo: { ...profileData.contactInfo.basicContactInfo, website: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='linkedInId'
                    type="text"
                    label="LinkedIn"
                    value={profileData?.contactInfo?.socialMedia?.linkedInId}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, socialMedia: { ...profileData.contactInfo.socialMedia, linkedInId: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='instagramId'
                    type="text"
                    label="Instagram"
                    value={profileData?.contactInfo?.socialMedia?.instagramId}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, socialMedia: { ...profileData.contactInfo.socialMedia, instagramId: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='twitterId'
                    type="text"
                    label="X"
                    value={profileData?.contactInfo?.socialMedia?.twitterId}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, socialMedia: { ...profileData.contactInfo.socialMedia, twitterId: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
            <Box sx={{ wordWrap: "break-word", gridColumn: { desktop: 'span 2', mobile: 'span 2' } }}>
                <TextField
                    id='facebookId'
                    type="text"
                    label="Facebook"
                    value={profileData?.contactInfo?.socialMedia?.facebookId}
                    placeholder='Enter text here'
                    showClearButton
                    maxLength={75}
                    onChange={e => onValueChanged({ contactInfo: { ...profileData.contactInfo, socialMedia: { ...profileData.contactInfo.socialMedia, facebookId: e.target.value } } })}
                    readOnly={isReadOnly}
                />
            </Box>
        </Box>
    </Box>;
};

export default CompanyContactInformation;
